export default function MidCTA() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative py-20 overflow-hidden bg-[#B8956A]">
      {/* Subtle texture overlay */}
      <div
        className="absolute inset-0 opacity-8"
        style={{
          backgroundImage:
            'repeating-linear-gradient(45deg, #fff 0, #fff 1px, transparent 0, transparent 30px)',
        }}
      ></div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 md:px-12 text-center">
        <p
          className="text-white/70 text-[11px] font-bold uppercase tracking-[0.22em] mb-4"
          style={{ fontFamily: 'Montserrat, sans-serif' }}
        >
          No Obligation
        </p>
        <h2
          className="text-3xl md:text-4xl font-bold text-white mb-5 leading-tight"
          style={{ fontFamily: 'Montserrat, sans-serif' }}
        >
          Ready to Start Your Project?
        </h2>
        <p
          className="text-white/80 text-lg mb-10 max-w-xl mx-auto leading-relaxed"
          style={{ fontFamily: 'Lora, serif' }}
        >
          Get a clear estimate with transparent pricing — no surprises, no pressure. Just honest, professional service.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => scrollTo('contact')}
            className="inline-flex items-center justify-center gap-2 bg-[#1A1A1A] hover:bg-[#111] text-white font-bold px-10 py-4 text-sm tracking-[0.12em] uppercase transition-all duration-300 hover:-translate-y-0.5 whitespace-nowrap cursor-pointer"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            Get My Free Estimate
          </button>
          <a
            href="tel:5153215711"
            className="inline-flex items-center justify-center gap-2.5 border border-white/50 hover:border-white text-white font-bold px-10 py-4 text-sm tracking-[0.12em] uppercase transition-all duration-300 hover:bg-white/10 whitespace-nowrap"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            <i className="ri-phone-fill"></i> 515-321-5711
          </a>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-6 mt-10">
          {[
            { icon: 'ri-shield-check-fill', label: 'Licensed & Insured' },
            { icon: 'ri-user-star-fill', label: 'Owner on Every Job' },
            { icon: 'ri-time-fill', label: 'On-Time Delivery' },
          ].map((item, i) => (
            <div key={i} className="flex items-center gap-2">
              <i className={`${item.icon} text-white/70 text-sm`}></i>
              <span
                className="text-white/80 text-xs font-semibold"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                {item.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
